import { FC } from 'react';
import cn from 'classnames';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { FeatureFlagDisplay, Icon } from '@app/components';
import { useAppContext } from '@app/contexts';
import { UserPersonalInfo } from '@app/hooks';
import { Feature, ShapeWithClassName } from '@app/constants';

import { getUsersInitials } from './getUsersInitials';

import './AccountIcon.scss';

const cnBem = createBemBlockBuilder(['accountIcon']);

export const AccountIcon: FC<ShapeWithClassName> = ({ className }) => {
  const { patronSession, isLoggedIn } = useAppContext();

  const getUnauthorizedUser = () => (
    <Icon
      icon={faUser}
      className={cn(cnBem('__icon'), {
        [cnBem('__icon--loggedIn')]: isLoggedIn,
      })}
    />
  );

  const getAuthorizedUser = () => (
    <div className={cnBem('__username')}>
      <FeatureFlagDisplay
        flagToMatch={{ name: Feature.consortiaLoginFlow }}
        renderOn={() => getUnauthorizedUser()}
        renderOff={() =>
          getUsersInitials(patronSession?.user as Partial<UserPersonalInfo>)
        }
      />
    </div>
  );

  return (
    <div className={cn(cnBem('__wrapper'), className)}>
      {isLoggedIn ? getAuthorizedUser() : getUnauthorizedUser()}
    </div>
  );
};
